<div class="appLayout">
  <mat-toolbar color="primary" class="toolbar site-navbar">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>

    <a routerLink="/">
      <img
        src="assets/{{ isTestVersion() ? 'shooting_global_logo_test_v4.svg' : 'shooting_global_logo_v4.svg' }}"
        alt="Logo"
        style="height: 32px"
      />
    </a>
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="/public/competitions/calendar">
        <span i18n>Calendar & Live Results</span>
      </button>
      <mat-divider></mat-divider>
      <a mat-menu-item routerLink="/progress/dashboard" i18n>Progress</a>
      <mat-divider></mat-divider>
      <button mat-menu-item [mat-menu-trigger-for]="organizationsMenu" i18n>Organizations</button>
      <button mat-menu-item [routerLink]="formatOrgRoute('competitions')" [disabled]="disableOrganizationsResources()">
        <span i18n>Competitions</span>
      </button>
    </mat-menu>
    <a routerLink="/public/competitions/calendar" i18n>Calendar</a>
    <a routerLink="/public/competitions/calendar" i18n>Results</a>
    <div style="flex: 1 1 auto; display: flex; align-self: stretch; flex-wrap: wrap"></div>
    <button mat-icon-button [matMenuTriggerFor]="translateMenu">
      <mat-icon>translate</mat-icon>
    </button>
    <mat-menu #translateMenu="matMenu">
      <button mat-menu-item (click)="switchLang('en-US')">🇺🇸 English</button>
      <button mat-menu-item (click)="switchLang('pl')">🇵🇱 Polish</button>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="loginMenu">
      <mat-icon>person</mat-icon>
    </button>
    <mat-menu #loginMenu="matMenu">
      @if (tokenService.userLoggedIn | async) {
        <a mat-menu-item routerLink="/settings/profile">{{ userEmail() }}</a>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()" i18n>Log out</button>
      } @else {
        <button mat-menu-item routerLink="/auth/login" i18n>Log in</button>
        <button mat-menu-item routerLink="/auth/register" i18n>Register</button>
      }
    </mat-menu>

    <mat-menu #organizationsMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let organization of userOrganizationsService.cachedOrganizations()"
        [routerLink]="'/organizations/' + organization.orgId"
        (click)="changeOrganizationGlobal(organization.orgId)"
      >
        @if (selectedOrganization() === organization) {
          <mat-icon>check</mat-icon>
        }
        {{ organization.name }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item routerLink="/organizations" i18n>Organizations list</button>
    </mat-menu>
  </mat-toolbar>
  <div *ngIf="orgId == null" style="text-align: center" i18n>ℹ️ Select organization from user menu</div>
  <div style="flex-grow: 1; overflow: scroll; margin: 0 0px">
    <router-outlet></router-outlet>
  </div>
</div>
